 
import React from 'react';

import { PalmettoIcon } from '@palmetto/dsm-components';
import classNames from 'classnames';
import { Button, ButtonProps } from '@helios/frontend-core';

export const CloseButton: React.FC<Omit<ButtonProps, 'children'>> = ({
  emphasis = 'tertiary',
  ...props
}: Omit<ButtonProps, 'children'>) => {
  const trackingId = props.trackingId || props.id;

  return (
    <Button
      {...props}
      type="button"
      aria-label="close modal"
      trackingId={`${trackingId}-close`}
      emphasis={emphasis}
      className={classNames(
        props.className,
        'p-0',
        emphasis === 'tertiary' && 'text-text-secondary hover:text-text-primary active:text-text-primary',
      )}
    >
      <PalmettoIcon name="x" aria-label="close button" />
    </Button>
  );
};
